export default __webpack_public_path__ + "static/media/add.3407a03e.svg";